import { ReactNode } from 'react';
import Divide from './Divide';

export function MenuHeader({ children }: { children: ReactNode }) {
    return (
        <>
            <div className="alli-px-4 alli-py-3 alli-text-sm alli-text-gray-700">
                {children}
            </div>
            <Divide />
        </>
    );
}

export function HeaderText({ children }: { children: ReactNode }) {
    return (
        <p className="alli-truncate alli-text-sm alli-font-medium alli-text-blue-gray-700">
            {children}
        </p>
    );
}
